/** @jsxImportSource @emotion/react */

import { css } from "@emotion/react";
import { useEffect } from "react";
import { useState, forwardRef } from "react";
import Swal from "sweetalert2";
import axios from "axios";
import Loading from "./Loading";
import Layout from "./Layout";
import { DataGrid } from "@mui/x-data-grid";
import AddIcon from "@mui/icons-material/Add";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import { loginState, configState } from "../lib/State";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import { AppBar, Toolbar, IconButton } from "@mui/material";
import get_login from "../lib/get_login";
import is_admin from "../lib/is_admin";
import ReportMarketingQuestionAdd from "./ReportMarketingQuestionAdd";
import ReportMarketingQuestionEdit from "./ReportMarketingQuestionEdit";
import XChangeData from "./XChangeData";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function ReportMarketingQuestion() {
  const [login, setLogin] = useState(loginState);
  const [loaded, setLoaded] = useState(false);
  const [rows, setRows] = useState([]);
  const [seq, setSeq] = useState(-1);
  const [showAdd, setShowAdd] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const token = localStorage.getItem("token");
  const [data, setData] = useState({ title: "", date: "" });

  const columns = [
    { field: "id", headerName: "id", hide: true },
    { field: "gubun", headerName: "구분", width: 100 },
    { field: "question", headerName: "문항", flex: 1 },
    { field: "regdate", headerName: "등록일", width: 200 },
    { field: "active", headerName: "활성화", width: 80 },
  ];

  const onCloseAddPop = () => {
    setShowAdd(false);
    load_data();
  };

  const onCloseEditPop = () => {
    setShowEdit(false);
    load_data();
  };

  const onOpenAdd = () => {
    setShowAdd(true);
  };

  // 리스트
  const load_data = async () => {
    let result = await axios.post(
      `${process.env.REACT_APP_API}/gympass_admin/ma_question`,
      {
        token: token,
        level: login.level,
        mcd: login.mcd,
        ...data,
      }
    );
    if (result.data.success === 1) {
      setRows(result.data.rows);
    } else {
      Swal.fire(result.data.msg);
      return;
    }
  };

  // 로그인
  useEffect(() => {
    const start = async () => {
      let result;
      result = await get_login();
      setLogin(result.data.login);
      result = await is_admin(result.data.login);
      if (!result) {
        window.location.href = "/";
      }
      setLoaded(true);
    };
    start();
  }, []);

  // 리스트
  useEffect(() => {
    if (loaded) load_data();
  }, [loaded]);

  return loaded === false ? (
    <Loading></Loading>
  ) : (
    <Layout login={login}>
      <h3
        css={css`
          margin-top: 10px;
        `}
      >
        마케팅 문항 관리
      </h3>

      {/* 옵션 */}
      <Box display="flex" sx={{ mb: 1, gap: 1, maxWidth: "1300px" }}>
        <Box>
          <FormControl fullWidth size="small" sx={{ width: 160 }}>
            <InputLabel>구분</InputLabel>
            <Select
              name="gubun"
              label="구분"
              onChange={(e) => {
                XChangeData(e, setData);
              }}
              value={data.gubun?data.gubun:''}
            >
              <MenuItem value="마케팅">마케팅</MenuItem>
              <MenuItem value="근무태도">근무태도</MenuItem>
              <MenuItem value="FC">FC업무</MenuItem>
            </Select>
          </FormControl>
        </Box>

        <Box>
          <TextField
            sx={{ width: 160 }}
            name="title"
            label="문항"
            size="small"
            onChange={(e) => {
              XChangeData(e, setData);
            }}
            autoComplete="off"
            value={data.title}
          />
        </Box>
        <Button
          sx={{ fontSize: 15 }}
          variant="contained"
          onClick={load_data}
          size="small"
        >
          조회
        </Button>
        <Button
          sx={{ ml: "auto" }}
          variant="contained"
          color="primary"
          startIcon={<AddIcon />}
          onClick={onOpenAdd}
        >
          문항 추가
        </Button>
      </Box>

      <DataGrid
        css={css`
          max-width: 1300px;
          min-height: 500px;
        `}
        rows={rows}
        columns={columns}
        pageSize={10}
        rowsPerPageOptions={[5]}
        checkboxSelection={false}
        onRowClick={(params) => {
          setSeq(params.row.id);
          setShowEdit(true);
        }}
      />

      <Dialog
        open={showAdd}
        fullWidth={true}
        maxWidth="md"
        TransitionComponent={Transition}
        onClose={() => {}}
      >
        <AppBar sx={{ position: "static" }}>
          <Toolbar>
            <Box sx={{ flexGrow: 1 }}>
              <Typography style={{ fontSize: 18 }}>마케팅 문항 추가</Typography>
            </Box>
            <IconButton
              edge="start"
              color="inherit"
              onClick={onCloseAddPop}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
        <ReportMarketingQuestionAdd login={login} onClose={onCloseAddPop} />
      </Dialog>

      <Dialog
        open={showEdit}
        fullWidth={true}
        TransitionComponent={Transition}
        onClose={() => {}}
        maxWidth="md"
      >
        <AppBar sx={{ position: "static" }}>
          <Toolbar>
            <Box sx={{ flexGrow: 1 }}>
              <Typography style={{ fontSize: 18 }}>마케팅 문항 수정</Typography>
            </Box>
            <IconButton
              edge="start"
              color="inherit"
              onClick={onCloseEditPop}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
        <ReportMarketingQuestionEdit
          login={login}
          onClose={onCloseEditPop}
          seq={seq}
        />
      </Dialog>
    </Layout>
  );
}
